import React, { useEffect } from "react";
import { FormFull } from "form-full";
import Styles from "../styles/";
import { Grid, Select } from "@material-ui/core";
import {
  Input,
  InputAutocomplete,
  InputDate,
  InputTags,
} from "../../../components/index";
import { Label } from "../../../components/inputs/Input";
import { fonts, Spacing } from "../../../config";
import { addOneDay } from "../../registerTenant/components/ModalRegistry";
import { masks, validations } from "../../../utils";
import { AccessTime } from "@material-ui/icons";

function Filters({
  onSubmit,
  loading,
  placeList,
  statusList,
  profileList,
}: any) {
  const [formRef, setFormRef] = React.useState<any>(null);
  const [minDate, setMinDate] = React.useState<any>(null);

  return (
    <FormFull formRef={setFormRef} onSubmit={(data) => onSubmit(data)}>
      <Grid alignItems="flex-end" container spacing={1}>
        <Styles.CustomGrid container item xs={12} md={6} lg={1}>
          <Label>Perfil</Label>
          <InputTags
            readOnly={false}
            name="type"
            options={profileList ? profileList : []}
            defaultValue={formRef?.type || null}
          />
        </Styles.CustomGrid>
        <Styles.CustomGrid item xs={12} md={6} lg={1}>
          <Label>Nome</Label>
          <Input name="name" label="" placeholder="Nome" />
        </Styles.CustomGrid>
        <Styles.CustomGrid container item xs={12} md={6} lg={1}>
          <Label>Imóvel</Label>
          <InputTags
            readOnly={false}
            name="placeNames"
            options={placeList ? placeList : []}
            defaultValue={formRef?.placeNames || null}
            multiple={true}
            
          />
        </Styles.CustomGrid>
        <Styles.CustomGrid container item xs={12} md={6} lg={1}>
          <Label>Solicitação</Label>
          <InputDate
            onChange={(value) => {
              setMinDate(value);
              const end = formRef?.getValue("startDate");

              if (end < value) {
                formRef?.clearValue("startDate", false);
              }
            }}
            name="solicitationDate"
          />
        </Styles.CustomGrid>
        <Styles.CustomGrid item xs={12} md={4} lg={1}>
          <Label>Check-In</Label>
          <InputDate
            onChange={(value) => {
              setMinDate(value);
              const end = formRef?.getValue("endDate");

              if (end < value) {
                formRef?.clearValue("endDate", false);
              }
            }}
            name="startDate"
          />
        </Styles.CustomGrid>
        <Styles.CustomGrid item xs={12} md={4} lg={1}>
          <Label>Check-Out</Label>
          <InputDate
            onChange={(value) => {
              setMinDate(value);
              const start = formRef?.getValue("startDate");
              if (start > value) {
                formRef?.clearValue("startDate", false);
              }
            }}
            name="endDate"
          />
        </Styles.CustomGrid>
        <Styles.CustomGrid item xs={12} md={3} lg={1}>
          <Label>Nº Acomp.</Label>
          <Input name="nhospedes" placeholder="Nº Acomp" />
        </Styles.CustomGrid>
        <Styles.CustomGrid item xs={12} md={4} lg={1}>
          <Label>Status</Label>
          <InputTags
            readOnly={false}
            name="status"
            options={statusList ? statusList : []}
            defaultValue={formRef?.status || null}
          />
        </Styles.CustomGrid>
      </Grid>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <Styles.ButtonContainer>
          <Styles.Clear
            loading={loading}
            disabled={loading}
            fullWidth={false}
            action="clear"
          >
            Limpar
          </Styles.Clear>
        </Styles.ButtonContainer>
        <Styles.ButtonContainer>
          <Styles.Submit
            loading={loading}
            disabled={loading}
            fullWidth={false}
            action="submit"
          >
            Aplicar Filtros
          </Styles.Submit>
        </Styles.ButtonContainer>
      </div>
    </FormFull>
  );
}

export default Filters;
